<template>
    <div
        v-if="isVisible"
        class="toast"
        :class="toastClass"
        :style="toastStyle"
        @animationend="handleAnimationEnd"
    >
        <div class="toast-content">
            <div class="status-dot"></div>
            <slot>{{ message }}</slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        offset: {
            type: Number,
            default: 20,
        },
        duration: {
            type: Number,
            default: 5,
        },
        message: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'info', // 默认类型为 info
            validator: (value) => ['error', 'info'].includes(value), // 限制类型为 error 或 info
        },
    },
    data() {
        return {
            isVisible: false,
            rightOffset: 100,
            topOffset: 11, // 初始位置为 11vh
            opacity: 1, // 初始透明度为 1
        };
    },
    computed: {
        // 动态计算样式
        toastStyle() {
            return {
                right: `${this.rightOffset}vw`,
                top: `${this.topOffset}vh`,
                opacity: this.opacity,
            };
        },
        // 根据类型动态添加类名
        toastClass() {
            return {
                'toast-error': this.type === 'error',
                'toast-info': this.type === 'info',
            };
        },
    },
    watch: {
        visible: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.show();
                } else {
                    this.hide();
                }
            },
        },
    },
    methods: {
        show() {
            this.isVisible = true;
            this.rightOffset = this.offset;
            this.topOffset = 10; // 初始位置为 10vh
            this.opacity = 0; // 初始透明度为 0

            // 动画：从 10vh 到 11vh，透明度从 0 到 1
            setTimeout(() => {
                this.topOffset = 11; // 动画结束位置
                this.opacity = 1; // 透明度变为 1
            }, 0);

            // 设置隐藏逻辑
            setTimeout(() => {
                this.hide();
            }, this.duration * 1000);
        },
        hide() {
            this.topOffset = 11; // 初始位置为 11vh
            this.opacity = 1; // 初始透明度为 1

            // 动画：从 11vh 到 14vh，透明度从 1 到 0
            setTimeout(() => {
                this.topOffset = 14; // 动画结束位置
                this.opacity = 0; // 透明度变为 0
            }, 0);

            // 等待动画完成后再隐藏提示框
            setTimeout(() => {
                this.isVisible = false; // 隐藏提示框
                this.rightOffset = 100; // 重置位置
            }, 500); // 确保动画完成
        },
        handleAnimationEnd() {
            if (this.isVisible) {
                this.rightOffset = 100;
            }
        },
    },
};
</script>

<style scoped>
.toast {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 20px;
    border-radius: 5px;
    transition: top 0.5s ease-in-out, opacity 0.5s ease-in-out;
    z-index: 2000;
    background-color: var(--detail-bgcolor);
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
    border: 1px solid #0b4948;
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.toast-content {
    display: flex;
    align-items: center;
    justify-content: center;

}

/* 根据类型添加不同的样式 */
.toast.toast-info {
    color: white;
}

.toast.toast-info .status-dot {
    width: 8px;
    height: 8px;
    background: #00ff96;
    border-radius: 50%;
    animation: pulse 2s infinite;
    margin-right: 10px;
}

.toast.toast-error {
    color: white;
}

.toast.toast-error .status-dot {
    width: 8px;
    height: 8px;
    background: #ff0000;
    border-radius: 50%;
    animation: pulse1 2s infinite;
    margin-right: 10px;
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(0, 255, 150, 0.5);
    }
    70% {
        box-shadow: 0 0 0 10px rgba(0, 255, 150, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(0, 255, 150, 0);
    }
}

@keyframes pulse1 {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.5);
    }
    70% {
        box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
    }
}
</style>